module.exports = __webpack_public_path__ + "img/direct-transfer.e34db6ff.svg";